<template>
  <BCard class="!rounded-2xl">
    <!-- Header Section with Back Arrow -->
    <div class="flex items-center gap-[.75rem] mb-[1.5rem]">
      <BButton
        variant="link"
        class="btn-icon rounded-lg border shadow-xs p-[.5rem]"
        @click="$router.push({ name: 'overtime-data' })"
      >
        <span class="k-arrow-left-2 text-[18px] text-black" />
      </BButton>
      <div class="text-black text-2xl font-semibold">
        Setting Approval Chain
      </div>
    </div>

    <!-- Info Banner Alert -->
    <div class="flex items-start gap-[.75rem] p-[1rem] rounded-2xl bg-[#F0F9FF] border-solid border-[1px] border-[#D5EFFF] mb-[1.5rem]">
      <span class="k-info-circle text-[20px] text-[#08A0F7] shrink-0 mt-[.125rem]" />
      <p class="text-[#475569] leading-relaxed mb-0">
        Konfigurasi alur persetujuan lembur untuk seluruh perusahaan. Anda dapat mengatur hirarki per divisi, menentukan approver final global, dan membuat pengecualian khusus untuk individu tertentu.
      </p>
    </div>

    <!-- Tab Navigation Pills -->
    <div class="flex flex-wrap items-center gap-1.5 bg-[#F5F5F5] p-1.5 rounded-2xl w-fit mb-[1.5rem]">
      <BButton
        v-for="tab in tabs"
        :key="tab.key"
        variant="light"
        class="transition-all"
        :class="activeTab === tab.key ? 'bg-white text-black shadow-xs' : '!text-[#737373]'"
        @click="activeTab = tab.key"
      >
        {{ tab.label }}
      </BButton>
    </div>

    <!-- Tab 1: Approval Chain per Divisi -->
    <TabApprovalChainDivision v-if="activeTab === 'division'" />

    <!-- Tab 2: Approver Final (Global) -->
    <TabApproverFinalGlobal v-else-if="activeTab === 'global'" />

    <!-- Tab 3: Override per Individu -->
    <TabOverrideIndividu v-else-if="activeTab === 'override'" />
  </BCard>
</template>

<style scoped>
::v-deep .btn-light {
  border-radius: 10px !important;
}
</style>

<script>
import TabApprovalChainDivision from './components/TabApprovalChainDivision.vue'
import TabApproverFinalGlobal from './components/TabApproverFinalGlobal.vue'
import TabOverrideIndividu from './components/TabOverrideIndividu.vue'

export default {
  name: 'SettingApprovalChain',
  components: {
    TabApprovalChainDivision,
    TabApproverFinalGlobal,
    TabOverrideIndividu,
  },
  data() {
    return {
      activeTab: 'division',
      tabs: [
        { key: 'division', label: 'Approval Chain per Divisi' },
        { key: 'global', label: 'Approver Final (Global)' },
        { key: 'override', label: 'Override per Individu' },
      ],
    }
  },
  mounted() {
    if (this.$route.query.tab && ['division', 'global', 'override'].includes(this.$route.query.tab)) {
      this.activeTab = this.$route.query.tab
    }
  },
}
</script>
